
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "ActionsCell",
  methods: {
    resolveRowLink(rowButton: any, item: any) {
      const to = rowButton.to ?? rowButton.pageLink ?? "";
      return typeof to === "function" ? to(item) : to;
    },
  },
  emits: ["open-modal", "delete", "inactiveLink", "row-action"],
  props: {
    routeKey: { type: String, required: true },
    mapping: { type: Object as PropType<any>, required: true },
    item: { type: Object as PropType<any>, required: true },
    index: { type: Number, default: 0 },
  },
});
